const Drawer = {
  parts: ["dialog", "header", "body", "overlay", "dialogContainer"],
  variants: {
    secondary: {
      overlay: {
        top: '0 !important',
        backgroundColor: "white",
        height: '120dvh !important',
        position: 'absolute !important'
      },
      dialogContainer: {
        // backgroundColor: "white",
        height: '120dvh !important',
      },
      body: {
        height: '120dvh !important',
      },
      dialog: {
        // backgroundColor: "white",
      },
    },
    sidebar: {
      overlay: {
        top: '0 !important',
        backgroundColor: "black",
        height: '120dvh !important',
        position: 'absolute !important'
      },
      dialogContainer: {
        // backgroundColor: "green",
        height: '120dvh !important',
      },
      body: {
        height: '120dvh !important',
      },
      dialog: {
        // backgroundColor: "red",
      },
    },
  },
}
export default Drawer
